import { useState } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldCheck } from '@fortawesome/pro-regular-svg-icons/faShieldCheck';

import { BackgroundCheckRequestService } from 'us-web-services';
import { Button, ButtonType } from '../../../components';
import { useDependencies } from '../../../dependencies';

interface Props {
  isBanner?: boolean;
}

export const BackgroundCheckRequest = ({ isBanner }: Props): JSX.Element | null => {
  const { t } = useTranslation();
  const { stores } = useDependencies();
  const userId = stores.user.user?.id;
  const [submitting, setSubmitting] = useState(false);

  if (!userId) return null;

  const sendRequest = async (): Promise<void> => {
    if (submitting) return;
    setSubmitting(true);
    try {
      await BackgroundCheckRequestService.create(userId);
      toast.success(t('pages.backgroundCheckRequest.success'));
    } catch (err) {
      console.warn('[BackgroundCheckRequest] send failed', err);
      toast.error(t('pages.backgroundCheckRequest.error'));
    } finally {
      setSubmitting(false);
    }
  };

  if (isBanner) {
    return (
      <Button
        buttonType={ButtonType.tertiary}
        id='background-check-request-banner'
        onClick={sendRequest}
        disabled={submitting}
        className='flex w-full items-center gap-3 text-left bg-white border border-neutral-200 rounded p-3 mt-4 hover:bg-neutral-50 disabled:opacity-60'
      >
        <FontAwesomeIcon icon={faShieldCheck} className='text-3xl text-sapphire flex-shrink-0' />
        <span className='font-light'>{t('pages.backgroundCheckRequest.bannerText')}</span>
      </Button>
    );
  }

  return (
    <Button
      buttonType={ButtonType.secondary}
      id='background-check-request-sidebar'
      onClick={sendRequest}
      disabled={submitting}
      className='block w-full text-left border border-neutral-200 rounded p-3 mt-4 hover:bg-neutral-50 disabled:opacity-60'
    >
      <span className='block font-light text-sm'>
        {t('pages.backgroundCheckRequest.sidebarText')}{' '}
        <span className='underline font-medium'>{t('pages.backgroundCheckRequest.contactUs')}</span>.
      </span>
    </Button>
  );
};
